import request from '@/util/request'

const api = {
  service: '/service',
  orgTree: '/org/tree',
  publicApi: 'http://wysgw.lylcc.com'//http://gw.wyschina.com  http://wysgw.lylcc.com
}

export default api

// 分页开放
export function getMenuOpenList (pId,type,current,pageSize) {
  return request({
    url: '/menu/open/page',
    method: 'POST',
    params:{
      pId:pId,
      type:type,
      current:current,
      pageSize:pageSize
    }
  })
}

// 新的目录分页点击量
export function getOpenAddHits(id) {
  return request({
    url: `/menu/open/hits/${id}`,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/publicApi.js